import { gql } from '@apollo/client'
import { sharedEventDataFragment } from '~/graphql/fragments/sharedEventData'
import money from '~/graphql/fragments/money'
import publicUserListingSeller from '~/graphql/fragments/publicUserListingSeller'
import publicListingDetails from '~/graphql/fragments/publicListingDetails'
import eventTypeListing from '~/graphql/fragments/eventTypeListing'

export const GET_CART_AND_LISTING = gql`
  query getCartAndListing($id: ID!, $hash: String!, $isLoggedIn: Boolean!) {
    viewer @include(if: $isLoggedIn) {
      id
      cart {
        id
        tickets {
          id
        }
      }
    }
    listing(id: $id, hash: $hash) {
      ...publicListingDetails
      event {
        ...sharedEventData
      }
      eventType {
        ...eventTypeListing
      }
      seller {
        ...publicUserListingSeller
      }
      price {
        sellerPrice {
          ...money
        }
        serviceFeeForBuyer {
          ...money
        }
        transactionFeePerTicket {
          ...money
        }
        totalPriceWithTransactionFee {
          ...money
        }
        originalPrice {
          ...money
        }
      }
    }
  }
  ${money}
  ${sharedEventDataFragment}
  ${eventTypeListing}
  ${publicUserListingSeller}
  ${publicListingDetails}
`
